export const OPEN_DOCUMENTS_MENU = '@documents/OPEN_DOCUMENTS_MENU'
export const CLOSE_DOCUMENTS_MENU = '@documents/CLOSE_DOCUMENTS_MENU'
